export default __webpack_public_path__ + "static/media/butcher7.3799a4b7.png";